import React, { useState } from 'react';
import { Avatar, Menu, MenuItem, IconButton } from '@mui/material';
//import SettingsIcon from '@mui/icons-material/Settings';
import { auth } from '../firebase-config'; // Import Firebase auth

function UserProfile({ user }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    auth.signOut()
      .then(() => {
        console.log('User signed out');
        handleClose(); // Close the menu after signing out
      })
      .catch((error) => {
        console.error('Error signing out: ', error);
      });
  };

  return (
    <div className="profile-icon-container">
      <IconButton onClick={handleClick}>
        {/* Display user's profile picture if available, otherwise show a default icon */}
        <Avatar alt={user.displayName || "User Profile"} src={user.photoURL || "/path-to-default-avatar.jpg"} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose}>Profile</MenuItem>
        <MenuItem onClick={handleClose}>Account Settings</MenuItem>
        <MenuItem onClick={handleLogout}>Logout</MenuItem> {/* Call handleLogout when Logout is clicked */}
      </Menu>
    </div>
  );
}

export default UserProfile;
